import React, { useMemo } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  styled,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import "./index.css";
import Image from "next/image";
import { AddToCartService } from "../../../services/cart";
import { Guide } from "./Guide";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";
import MaxServiceAlert from "./MaxServiceAlert";

interface CardProps {
  id: any;
  cid: any;
  url: any;
  heading: any;
  subHeading: any;
  finalPrice: any;
  discount: any;
  price: any;
  serviceDetails: any;
  handleViewDetails: any;
  handleOpenViewDetailsRsOne: any;
  addOn: any;
  updateCard: any;
  setUpdateCard: any;
  reloadViewDetailsItem: any;
  productDetailsAvailable: any;
  makeYourOwnPackage: boolean;
  handleEditPackage: any;
  recommendedServices: any;
  setOpenBestPaired: any;
  setRecommendedServices: any;
  serviceCharge: any;
  productCost: any;
  min: any;
  specialPrice: any;
  specialMessage: any;
}

export const Card: React.FC<CardProps> = ({
  id,
  cid,
  url,
  heading,
  subHeading,
  finalPrice,
  discount,
  price,
  serviceDetails,
  handleViewDetails,
  handleOpenViewDetailsRsOne,
  addOn,
  updateCard,
  setUpdateCard,
  reloadViewDetailsItem,
  productDetailsAvailable,
  makeYourOwnPackage,
  handleEditPackage,
  recommendedServices,
  setOpenBestPaired,
  setRecommendedServices,
  serviceCharge,
  productCost,
  min,
  specialPrice,
  specialMessage,
}) => {
  const [isClicked, setIsClicked] = React.useState(false);
  const [openMaxService, setOpenMaxService] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [value, setVaue] = React.useState(1);
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const currencyCode = useCurrencyCode();

  const ScrollContainer = styled(Box)`
    overflow: auto;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Webkit browsers */
    }
  `;
  React.useEffect(() => {
    var jsonCount = addToCartService.checkIfAvailable(id, cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setUpdateCard(false);
  }, [updateCard, addToCartService, id, cid, setUpdateCard]);

  const handleClickButton = async () => {
    setIsLoading(true);
    if (addOn == true) {
      handleOpenViewDetailsRsOne();
      setIsLoading(false);
    } else {
      var countJson = await addToCartService.addToCart(
        id,
        true,
        cid,
        url,
        serviceDetails,
        subHeading,
        serviceCharge,
        productCost,
        min,
        specialPrice,
        specialMessage
      );
      if (countJson?.count && countJson?.count > 0) {
        setVaue(countJson?.count);
        setIsClicked(true);
        reloadViewDetailsItem();
        setIsLoading(false);
      } else {
        setIsClicked(false);
        reloadViewDetailsItem();
        setIsLoading(false);
      }
    }
  };

  const handleValueDecrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      false,
      cid,
      url,
      serviceDetails,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson?.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      true,
      cid,
      url,
      serviceDetails,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleBestPaired = () => {
    setOpenBestPaired(true);
    setRecommendedServices(recommendedServices);
  };

  return (
    <>
      <Box
        className="salontym-service-card"
        key={"serviceCard" + id}
        sx={{
          height: "352px",
          borderRadius: "1.5rem",
          border: "1px solid rgba(18,53,36,0.08)",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,252,249,0.98) 100%)",
          boxShadow: "0 16px 40px rgba(18,53,36,0.1)",
          m: 0,
          minWidth: { xs: "265px", md: 0 },
          maxWidth: { xs: "270px", sm: "300px", md: "100%" },
          width: { md: "100%" },
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            overflow: "hidden",
            borderRadius: "1.5rem 1.5rem 0px 0px",
            height: "108px",
          }}
        >
          <Image
            src={url}
            alt="icon"
            className="card-image-animation"
            style={{
              objectFit: "cover",
              height: "108px",
              width: "100%",
              borderRadius: "1.5rem 1.5rem 0px 0px",
            }}
            width={500}
            height={200}
            // priority={true}
            // rel="preload"
            loading="lazy"
          />
        </Box>
        <Box sx={{ p: 2, boxSizing: "border-box" }}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1,
              rowGap: 0.75,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                flex: "1 1 auto",
                minWidth: 0,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: 0,
                  textTransform: "capitalize",
                  color: "#102117",
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  wordBreak: "break-word",
                }}
              >
                {heading}
              </Typography>
              {productDetailsAvailable == true && <Guide serviceId={id} />}
            </Box>
            {isClicked && recommendedServices?.length > 0 && (
              <Button
                variant="outlined"
                color="success"
                sx={{
                  textTransform: "capitalize",
                  fontSize: "10px",
                  padding: "5px 8px",
                  lineHeight: "12px",
                  whiteSpace: "nowrap",
                  flexShrink: 0,
                  borderRadius: "999px",
                  borderColor: "rgba(31,122,77,0.35)",
                  color: "#145635",
                  background: "rgba(223,246,232,0.6)",
                }}
                onClick={handleBestPaired}
              >
                Best paired
              </Button>
            )}
          </Box>
          <Typography
            variant="body2"
            sx={{
              fontSize: "11px",
              textWrap: "nowrap",
              overflow: "auto",
              mt: 0.5,
              textTransform: "capitalize",
              color: "#5e6d63",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {subHeading}
          </Typography>
          <ScrollContainer sx={{ height: "6.2rem", mt: 1 }}>
            {serviceDetails?.map((item: any, index: any) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginBottom: "4px",
                }}
                key={index}
              >
                <CheckIcon
                  sx={{
                    color: "#1f7a4d",
                    paddingRight: "6px",
                    fontSize: "1rem",
                    flexShrink: 0,
                    mt: "2px",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: "#32443a",
                    lineHeight: 1.35,
                    wordBreak: "break-word",
                    minWidth: 0,
                  }}
                >
                  {item}
                </Typography>
              </Box>
            ))}
          </ScrollContainer>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 0.5,
              mb: 1,
              overflow: "auto",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                color: "#000",
                fontSize: currencyCode == "NPR" ? "12px" : "16px",
              }}
            >
              {currencyCode}
              {finalPrice.toLocaleString()}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "100",
                paddingLeft: "10px",
                color: "gray",
                textDecoration: "line-through",
                fontSize: currencyCode == "NPR" ? "12px" : "13px",
              }}
            >
              {currencyCode}
              {price.toLocaleString()}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "bold",
                paddingLeft: "10px",
                color: "#1f7a4d",
                fontSize: currencyCode == "NPR" ? "12px" : "13px",
                background: "rgba(223,246,232,0.7)",
                padding: "4px 8px",
                borderRadius: "999px",
              }}
            >
              <span style={{ fontWeight: "100", color: "#15741a" }}>Save</span>
              &nbsp;
              {currencyCode}
              {discount.toLocaleString()}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
              gap: 1,
              alignItems: "center",
              width: "100%",
            }}
          >
            {makeYourOwnPackage ? (
              <Button
                variant="outlined"
                aria-hidden="false"
                sx={{
                  fontSize: "11px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  padding: "8px 10px",
                  borderRadius: "999px",
                  minWidth: 0,
                  width: "100%",
                  whiteSpace: "nowrap",
                  boxShadow: "none",
                  borderColor: "rgba(18,53,36,0.12)",
                  color: "#123524",
                  background: "rgba(255,255,255,0.74)",
                }}
                color="success"
                onClick={handleEditPackage}
              >
                Edit Package
              </Button>
            ) : (
              <Button
                variant="outlined"
                aria-hidden="false"
                sx={{
                  fontSize: "11px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  padding: "8px 10px",
                  borderRadius: "999px",
                  minWidth: 0,
                  width: "100%",
                  whiteSpace: "nowrap",
                  boxShadow: "none",
                  borderColor: "rgba(18,53,36,0.12)",
                  color: "#123524",
                  background: "rgba(255,255,255,0.74)",
                }}
                color="success"
                onClick={handleViewDetails}
              >
                View Details
              </Button>
            )}
            {isLoading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: 0,
                  width: "100%",
                  height: 36,
                  background: "none",
                  borderRadius: "999px",
                  border: "1px solid #1f7a4d",
                }}
              >
                <CircularProgress size="25px" color="success" />
              </Box>
            ) : isClicked ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  minWidth: 0,
                  width: "100%",
                  height: 36,
                  background:
                    "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
                  borderRadius: "999px",
                  color: "white",
                  boxShadow: "0 12px 24px rgba(18,53,36,0.24)",
                }}
              >
                <RemoveIcon
                  onClick={handleValueDecrease}
                  sx={{ cursor: "pointer", flexShrink: 0 }}
                />
                <Typography
                  sx={{
                    fontSize: "14px",
                    lineHeight: 1,
                  }}
                >
                  {value}
                </Typography>
                <AddIcon
                  onClick={handleValueIncrease}
                  sx={{ cursor: "pointer", flexShrink: 0 }}
                />
              </Box>
            ) : (
              <Button
                variant="contained"
                sx={{
                  fontSize: "11px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  padding: "8px 10px",
                  borderRadius: "999px",
                  minWidth: 0,
                  width: "100%",
                  whiteSpace: "nowrap",
                  background:
                    "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)",
                  boxShadow: "0 14px 28px rgba(18,53,36,0.2)",
                }}
                color="success"
                onClick={handleClickButton}
              >
                Add to Cart
              </Button>
            )}
          </Box>
        </Box>
      </Box>
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
    </>
  );
};

export default Card;
